/*
 * @description:: 广告组管理
 * @Author: chenminqun@batmobi.net
 * @Date: 2018-09-25 15:59:56
 * @LastEditors: yanzhigen@batmobi.net
 * @LastEditTime: 2018-11-17 16:05:05
 */
<template>
    <div id="group-detail">
        <!-- 顶部header模块 -->
        <header slot="header" class="c-body-header">
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 新建广告组 -->
                    <!-- <router-link :to="{path: '/newPromition', query: {type: 'campaign', action: 'add'}}" class="header-button-primary"
                        >新建广告组</router-link
                    > -->
                </div>
                <div class="header-row-right">
                    <!-- 预设日期按钮 -->
                    <c-date-picker
                        :startDay.sync="tableParams.startDay"
                        :endDay.sync="tableParams.endDay"
                        @change="getCampaignList"
                    />
                </div>
            </div>
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 搜索 -->
                    <Input
                        
                        v-model="tableParams.keyword"
                        placeholder="搜索广告组/ID"
                        class="header-search"
                        icon="android-search"
                        @on-keydown.enter="getCampaignList(true)"
                        @on-click="getCampaignList(true)"
                    />
                    <Input
                        v-model="tableParams.publisherName"
                        placeholder="搜索账号名(邮箱)"
                        class="header-search"
                        icon="android-search"
                        @on-keydown.enter="getCampaignList(true)"
                        @on-click="getCampaignList(true)"
                    />
                    <Button @click="onClickDown" type="primary">下载</Button>


                    <!-- 批量操作 -->
                    <!-- <div v-else class="edit-box">
                        <div class="edit">
                            已选择{{ selectedCount }}项
                            <span class="close-btn" @click.stop="onReSelectedAll">
                                <Icon type="close" />
                            </span>
                        </div>
                        <Dropdown @on-click="onChangeBatchType" trigger="click">
                            <button class="header-button-ghost">
                                <span class="header-button-ghost-span">
                                    <span>批量编辑</span>
                                </span>
                                <i class="icon header-button-ghost-down"></i>
                            </button>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="(item, index) in batchTypeList" :name="item" :key="index">{{
                                    item
                                }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div> -->
                </div>
                <div class="header-row-right">
                    <!-- 国家筛选 -->
                    <cExDropdown
                        v-model="tableParams.countries"
                        :sourceList="countryList"
                        code="code"
                        left="code"
                        leftName="国家代码"
                        right="name"
                        rightName="国家名称"
                        @changeCount="(val) => (countryCount = val)"
                    >
                        <a
                            slot="function-btn"
                            @click="
                                getCampaignList(true);
                                $el.click();
                            "
                            class="blue-btn"
                            >确定</a
                        >
                        <button class="header-button-ghost">
                            <span class="header-button-ghost-span" v-if="countryCount"
                                >国家：已选{{ countryCount }}项</span
                            >
                            <span class="header-button-ghost-span" v-else>国家：不限</span>
                            <i class="icon header-button-ghost-down"></i>
                        </button>
                    </cExDropdown>
                    <Dropdown trigger="click" @on-click="(val) => changeStatus('status', val)">
                        <button class="header-button-ghost">
                            <span class="header-button-ghost-span">状态：{{ statusValue[tableParams.status] }}</span>
                            <i class="icon header-button-ghost-down"></i>
                        </button>
                        <DropdownMenu slot="list">
                            <DropdownItem
                                v-for="(value, index) in statusList"
                                :name="value.name"
                                :selected="value.name == tableParams.status"
                                :key="index"
                                >{{ value.value }}</DropdownItem
                            >
                        </DropdownMenu>
                    </Dropdown>
                    <!-- 投放状态筛选 -->
                    <Dropdown trigger="click" @on-click="(val) => changeStatus('dropDownStatus', val)">
                        <button class="header-button-ghost">
                            <span class="header-button-ghost-span"
                                >投放状态：{{ dropdownStatusValue[tableParams.dropDownStatus] }}</span
                            >
                            <i class="icon header-button-ghost-down"></i>
                        </button>
                        <DropdownMenu slot="list">
                            <DropdownItem
                                v-for="(value, index) in dropdownStatusList"
                                :name="value.name"
                                :selected="value.name == tableParams.dropDownStatus"
                                :key="index"
                                >{{ value.value }}</DropdownItem
                            >
                        </DropdownMenu>
                    </Dropdown>
                    <!-- AUTO状态筛选 -->
                    <!-- <Dropdown
                        v-if="userData.autoType == 1"
                        trigger="click"
                        @on-click="(val) => changeStatus('offerBundleStatus', val)"
                    >
                        <button class="header-button-ghost">
                            <span class="header-button-ghost-span"
                                >AUTO状态：{{ offerBundleStatusValue[tableParams.offerBundleStatus] }}</span
                            >
                            <i class="icon header-button-ghost-down"></i>
                        </button>
                        <DropdownMenu slot="list">
                            <DropdownItem
                                v-for="(value, index) in offerBundleStatusList"
                                :name="value.name"
                                :selected="value.name == tableParams.offerBundleStatus"
                                :key="index"
                                >{{ value.value }}</DropdownItem
                            >
                        </DropdownMenu>
                    </Dropdown> -->
                    <!-- 自定义列 -->
                    <!-- <quota @onIndicatorList="onIndicatorList" type="group"></quota> -->
                    <!-- <button class="header-button-ghost" @click="onClickDown">
                        <span class="header-button-ghost-span">下载</span>
                    </button> -->
                    <!-- 刷新 -->
                    <button class="header-button-ghost refresh-btn" @click="getCampaignList(false)" title="刷新">
                        <i class="icon icon-refresh"></i>
                    </button>
                </div>
            </div>
        </header>
        <!-- 顶部header模块 -->
        <!-- 主体section模块 -->
        <section slot="section" class="c-body-section">
            <!-- 表格 -->
            <!-- <cTable
                @itemChange="confirmItem"
                type="campaign"
                :summary="summary"
                :tableDefaultIndicator="tableDefaultIndicator"
                @check="onSaveSelected"
                :originList="originData"
                :tableParams.sync="tableParams"
                :indicatorList="indicatorList"
                @change="getCampaignList(false)"
                @editBudget="showEditBudget"
                @editBidprice="showEditBidprice"
            /> -->
            <el-table
            :data="originData"
            style="width: 100%;border:1px solid #EBEEF5"
            @select="handleSelectionChange"
            ref="multipleTable"
            class="el-table_css"
            >   
                <el-table-column fixed type="selection"  width="70"> </el-table-column>
                <el-table-column fixed prop="code" label="ID" width="70"> </el-table-column>
                <el-table-column fixed prop="name" label="广告组名称" width="200">
                    <template slot-scope="scope" >
                            <span v-if="scope.$index == 0">{{scope.row.name}}</span>
                            <span v-else class="Css_tableName" @click="Fun_tableName(scope.row)">{{scope.row.name}}</span>
                    </template>
                </el-table-column>

                <el-table-column fixed prop="email" label="账号名（邮箱）" width="150"> </el-table-column>
                <el-table-column prop="seriesName" label="广告系列" width="120">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <!--  -->
                            <span>{{scope.row.seriesName}}</span>
                    </template>
                </el-table-column>

                <el-table-column  prop="install" label="状态" width="80">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <el-switch
                                @change="TableGZState(scope.row)"
                                v-model="scope.row.status"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                :active-value="1"
                                :inactive-value="0">
                            </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="dropDownStatus" label="投放状态" width="120">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <span v-if="scope.row.dropDownStatus" style="color:green">已投放</span>
                            <span v-else style="color:red">未投放</span>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="类型" width="120"> </el-table-column>
                <el-table-column prop="bid" label="竞价请求量" width="120"> </el-table-column>
                <el-table-column prop="imp" label="展现量" width="120"> </el-table-column>
                <el-table-column prop="click" label="点击量" width="120"> </el-table-column>
                <el-table-column prop="ctr" label="CTR" width="120"> </el-table-column>
                <el-table-column prop="cpa" label="CPA" width="120"> </el-table-column>
                <el-table-column prop="cpc" label="CPC" width="120"> </el-table-column>
                <el-table-column prop="cpm" label="CPM" width="120"> </el-table-column>
                <el-table-column prop="calculateImp" label="补/扣量后的clickimp数" width="140"> </el-table-column>
                <el-table-column prop="calculateClick" label="补/扣量后的click数" width="150"> </el-table-column>
                <el-table-column prop="calculateSpends" label="补/扣量后的花费数" width="140"> </el-table-column>
                <el-table-column prop="calculateCpc" label="补/扣量后的cpc" width="140"> </el-table-column>
                <el-table-column prop="calculateCpm" label="补/扣量后的cpm" width="140"> </el-table-column>
                <el-table-column prop="pcpa" label="PCPA" width="120"> </el-table-column>
                <el-table-column prop="pcpc" label="PCPC" width="120"> </el-table-column>
                <el-table-column prop="pcpm" label="PCPM" width="120"> </el-table-column>
                <!-- <el-table-column prop="install" label="安装量" width="120"> </el-table-column>
                <el-table-column prop="installRate" label="安装率" width="100"> </el-table-column> -->
                <el-table-column prop="deal" label="转化量" width="120"> </el-table-column>
                <el-table-column prop="dealRate" label="转化率" width="100"> </el-table-column>
                <el-table-column prop="ecpm" label="eCPM" width="120"> </el-table-column>
                <el-table-column prop="amount" label="收益" width="120"> </el-table-column>

                <el-table-column
                    fixed="right"
                    label="操作"
                    width="120">
                <template slot-scope="scope"  v-if="scope.$index != 0">
                    <el-button @click.native.prevent="onchangeItem('edit',scope.row.code,scope.row.publisherId)" type="text" size="small"> 编辑 </el-button>
                </template>

                </el-table-column>
        </el-table>

        </section>
        <!-- 出价 -->
        <cBid :show.sync="show" @save="submitBidPrice"></cBid>
        <!-- 预算 -->
        <cBudgetSimple :show.sync="show" @save="confirmBudget"></cBudgetSimple>
        <!-- 日期 -->
        <Modal v-model="show.date" width="500" class="c-modal" @on-ok="submitDate">
            <p slot="header" class="modal-header">修改日期</p>
            <div class="modal-detail">
                <div class="modal-row">
                    <span class="modal-row-label">日期：</span>
                    <!-- 日期选择 -->
                    <date-picker
                        :value="date"
                        class="modal-row-input"
                        type="daterange"
                        placement="bottom-end"
                        placeholder="选择日期，默认不限"
                        style="font-size: 0.1rem"
                        @on-change="onDateChange"
                    />
                </div>
            </div>
        </Modal>
        <!-- 日期 -->
        <!-- 时段 -->
        <Modal v-model="show.time" width="650" class="c-modal" @on-ok="submitTime">
            <p slot="header" class="modal-header">修改时段</p>
            <div class="modal-detail">
                <div class="modal-row">
                    <span class="modal-row-label">时段：</span>
                    <i-switch size="large" v-model="show.targetTime">
                        <span slot="open">指定</span>
                        <span slot="close">不限</span>
                    </i-switch>
                </div>
                <tiem-zone @timezone="onTargetTimeChange" :timezone="targetTime" :disabled="!show.targetTime" />
            </div>
        </Modal>
        <!-- 时段 -->
        <footer slot="footer" class="c-body-footer">
            <!-- 分页器 -->
            <c-page
                :table-params.sync="tableParams"
                :page-bean.sync="pageBean"
                class="foot-row"
                @on-change="getCampaignList(false)"
                @on-page-size-change="getCampaignList(true)"
            />
        </footer>
    </div>
</template>
<script>
import common from '@/utils/common';
import mixins from '@/mixins/index.js';
import tiemZone from '@/components/commons/Drag.vue';
import cBody from '@/components/commons/cBody.vue';
import cDatePicker from '@/components/commons/cDatePicker.vue';
import quota from '@/components/commons/quota.vue';
import cPage from '@/components/commons/cPage.vue';
import cTable from '@/components/commons/manageTable.vue';
import cBudgetSimple from '@/components/commons/cBudgetSimple.vue';
import cBid from '@/components/commons/cBid.vue';
import tablelist from '@/server/tablelist.js';
import cExDropdown from '@/components/commons/cExDropdown.vue';
import { mapState } from 'vuex';
export default {
    name: 'managementGroup',
    mixins: [mixins],
    components: {
        tiemZone,
        cTable,
        cBudgetSimple,
        cBid,
        cBody,
        cDatePicker,
        quota,
        cPage,
        cExDropdown,
    },
    props: {
        tagCampaign: {
            type: Number,
        },
    },
    data() {
        return {
            value:true,
            self:this,
            //编辑列表
            editList: [],
            //批量修改预算
            totalBudget: { totalBudget: '', totalImp: '', totalClick: '' },
            countryCount: 0,
            countryList: [],
            // dailyBudget: { dailyBudget: "", dailyImp: "", dailyClick: "" },
            date: [], //批量修改时期
            targetTime: '', //批量修改时段
            bidPrice: '', //批量修改出价价格
            //显示控制器
            show: {
                bidPrice: false,
                date: false,
                time: false,
                budget: false,
                targetTime: false,
                totalBudget: false,
                dailyBudget: false,
            },
            //推广列表数据
            originData: [],
            //分页对象
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 1,
            },
            //获取推广列表的参数
            tableParams: {
                page: 1,
                pageSize: 10,
                startDay: this.mixinGetDate('today'),
                endDay: this.mixinGetDate('today'),
                status: '',
                dropDownStatus: '',
                offerBundleStatus: '',
                keyword: '',
                orderName: 'code',
                orderType: 'desc',
                countries: '',
                dimension:'campaign',
                publisherName:"",
                // publisherId:'',
                // categoryCode:''
            },
            //汇总
            summary: {},
            //显示创意列表
            currentOffer: '',
            //状态列表
            //自动刷新开关,默认不打开
            autoRefresh: false,
            //自动刷新定时器
            autoInterval: '',
            //指标列表
            indicatorList: tablelist['group'],
            tableDefaultIndicator: [
                {
                    code: 'id',
                    id: 0,
                    selected: true,
                    isDefault: true,
                    name: 'ID',
                    sortor: true,
                },
                {
                    code: 'series',
                    id: 1,
                    selected: true,
                    isDefault: true,
                    name: '广告组名称',
                    sortor: false,
                },
                {
                    code: 'dropDownStatus',
                    id: 100,
                    selected: true,
                    isDefault: true,
                    name: '投放状态',
                    sortor: false,
                },
            ],
            batchTypeList: ['开启', '停止', '归档', '预算', '时段', '出价'],

            tableradio:[],
            echoList:[],
        };
    },
    watch: {
        tagCampaign: {
            handler(value) {
                if (!value) {
                    this.originData.map((item) => (item.selected = false));
                }
            },
            immediate: true,
        },
        'tableParams.status'(value) {
            if (value == '3') {
                this.batchTypeList = ['预算', '时段', '出价', '还原'];
            } else {
                this.batchTypeList = ['开启', '停止', '归档', '预算', '时段', '出价'];
            }
        },
    },
    computed: {
        ...mapState({
            userData: (state) => state.userData,
            dropdownStatusValue: (state) => state.promotionManagement.dropdownStatusValue,
            offerBundleStatusValue: (state) => state.promotionManagement.offerBundleStatusValue,
            statusList: (state) => state.promotionManagement.adminstatusList,
            offerBundleStatusList: (state) => state.promotionManagement.offerBundleStatusList,
            statusText: (state) => state.promotionManagement.statusText,
            statusColor: (state) => state.promotionManagement.statusColor,

            statusValue: (state) => state.promotionManagement.adminstatusValue,
            statusList: (state) => state.promotionManagement.adminstatusList,
            dropdownStatusList: (state) => state.promotionManagement.dropdownStatusList,
        }),
        //已选择
        selectedCount() {
            return this.originData.filter((item) => item.selected).length;
        },
        //已选择数组
        selectedList() {
            return this.originData.filter((item) => item.selected);
        },
    },
    mounted() {
        // if (this.$store.state.manageData.series && this.$store.state.manageData.series.tableParams) {
        //     this.tableParams = {
        //         ...this.$store.state.manageData.series.tableParams,
        //     };
        //     this.tableParams.status = '1';
        //     this.tableParams.keyword = '';
        //     this.tableParams.page = 1;
        //     this.tableParams.pageSize = 10;
        //     this.tableParams.orderName = 'id';
        //     this.tableParams.orderType = 'desc';
        // }
        // if (this.$store.state.manageData.group && this.$store.state.manageData.group.indicatorList) {
        //     this.indicatorList = {
        //         ...this.$store.state.manageData.group.indicatorList,
        //     };
        //     if (this.$store.state.manageData.group.tableParams) {
        //         this.tableParams = {
        //             ...this.$store.state.manageData.group.tableParams,
        //         };
        //     }
        // }

        this.$store.dispatch('mangeData', { name: 'clear-ad' });
        this.getCampaignList(false, true);
        this.getCountryList();
    },
    beforeDestroy() {
        clearInterval(this.autoInterval);
    },
    methods: {
        // 选择关联产品：打勾或取消
        handleSelectionChange(selecteds, row) {
            if (!this.echoList.includes(row.code)) {
                // 回显数据里没有本条，把这条加进来(选中)
                this.echoList.push(row.code);
            } else {
                // 回显数据里有本条，把这条删除(取消选中)
                this.echoList.forEach((id, index) => {
                if (id === row.code) {
                    this.echoList.splice(index, 1);
                }
            });
        }
        sessionStorage.setItem('Selection_Campaign',JSON.stringify(this.echoList));
        this.$emit('screenNum','Selection_Campaign',this.echoList.length)
        },
        //清空所选项
        Fun_Selection_cleos(){
            this.echoList = []
            this.$refs.multipleTable.clearSelection()
        },
        Fun_tableName(item){
            this.echoList = []
            this.$refs.multipleTable.clearSelection()
            this.echoList.push(item.code)
            sessionStorage.setItem('Selection_Campaign',JSON.stringify(this.echoList));
            // this.$refs.multipleTable.toggleRowSelection(item, true);

            this.$emit('onClickTab',{name:'adv-item'})
            this.$emit('screenNum','Selection_Campaign',this.echoList.length)
        },



         TableGZState(item){
            console.log('item',item)
            this.confirmItem(item)
        },  
        /**
         * @description 表格item操作
         * @param item
         */
         onchangeItem(action, id,publisherId) {
            let type = 'campaign'
            console.log(action, id)
            window.open(`${location.origin}/#/newPromition?type=${type}&action=${action}&id=${id}&publisherId=${publisherId}`,'_self');
        },

        /**
         * @desc:获取国家列表
         */
        async getCountryList() {
            const res = await this.$axios.get(this.$port.manager.getCountryList);
            this.countryList = res.data || [];
            this.countryList.forEach((item) => (item.selected = false));
        },
        /**
         * @desc: 报表下载
         */
         onClickDown() {
            const params = Object.assign({}, this.tableParams);
            params.rd = new Date().getTime();
            let queryString = `${this.$port.globalReport.downloadAdmin}?`;
            for (let i in params) {
                queryString += `${i}=${params[i]}&`;
            }
            
            window.location.href = queryString;
        },
        /**
         * @desc: 确认修改单项参数
         */
        async confirmItem(item) {
            const params = [
                {
                    id: item.code,
                    status: item.status,
                },
            ];
            const res = await this.$axios.post(this.$port.campaign.batchUpdate, params);
            this.afterSubmit(res);
            // if()
            // this.afterSubmit(res);
        },
        
        onSaveSelected() {
            this.$store.dispatch('mangeData', {
                name: 'group',
                value: {
                    selectCount: this.originData.filter((item) => item.selected).length,
                    selectArray: this.originData.filter((item) => item.selected),
                },
            });
        },
        /*
         * @desc: 获取指标列表更新
         */
        onIndicatorList(data) {
            this.$store.dispatch('mangeData', {
                name: 'group',
                value: {
                    indicatorList: this.deepClone(data),
                },
            });
            this.indicatorList = this.deepClone(data);
        },
        //全选
        onReSelectedAll() {
            this.originData.forEach((item) => (item.selected = false));
            this.onSaveSelected();
        },
        /*
         * @desc: 获取推广数据
         * @param isInit:boolean 是否初始化页数
         */
        async getCampaignList(isInit, loaded) {
            if (isInit) this.tableParams.page = 1;
            this.currentOffer = '';
            //获取表格数据 -获取汇总数据
            let params = { ...this.tableParams };
   
            if(sessionStorage.getItem('Selection_series') && JSON.parse(sessionStorage.getItem('Selection_series')).length > 0){
                let idArr = JSON.parse(sessionStorage.getItem('Selection_series'));
                params.parentIds = idArr.join(',');
            }


            const resList = await this.$axios.get(this.$port.seriesTable.groupList, { params });
            if (resList.data.pageBean) {
                this.pageBean = resList.data.pageBean;
            }
            if (resList.data.list) {
                this.originData = resList.data.list;

                this.echoList = sessionStorage.getItem('Selection_Campaign') ? JSON.parse(sessionStorage.getItem('Selection_Campaign')) : []
                this.$nextTick(() => {
                    this.originData.forEach(item => {
                        // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
                        // toggleRowSelection(item, true)：设置当前行数据为选中状态
                        if(this.echoList.length){
                            if (this.echoList.includes(item.code)) {
                                this.$refs.multipleTable.toggleRowSelection(item, true);
                            }
                        }
                    });
	            });


            }

        },
        /**
         * @desc: 状态筛选
         * @param {String} name: 选择的状态名
         * @param {String} value: 选择的状态值
         */
        changeStatus(name, value) {
            this.$set(this.tableParams, name, value);
            this.getCampaignList(true);
        },
        /**
         * @desc: 设置国家数组
         * @param countries:string 国家字符串
         * @param length:number 最大长度
         * @return string[] 国家数组
         */
        setCountryTag(countries, length) {
            if (!countries) countries = 'ALL';
            let countryTag = countries.split(',');
            if (countryTag.length > length) countryTag = [...countryTag.filter((a, i) => i < length - 1), '....'];
            return countryTag;
        },
        /**
         * @desc: 显示预算编辑
         * @param {Object} item:
         */
        showEditBudget(item) {
            this.show.dailyBudget = true;
            this.editList = [item];
        },
        /**
         * @desc: 显示预算编辑
         * @param {Object} item:
         */
        showEditBidprice(item) {
            this.show.bidPrice = true;
            this.editList = [item];
        },
        /**
         * @desc: 点击批量操作时
         * @param value:number or string 批量操作索引
         */
        onChangeBatchType(value) {
            if (this.selectedCount < 1) {
                this.$Message.warning({
                    content: '请先选择要批量操作的推广',
                    duration: 1.5,
                });
            } else {
                console.log(value);
                if (value == '出价') {
                    this.show.bidPrice = true; //打开出价
                    this.editList = [...this.selectedList];
                }
                if (value == '预算') {
                    this.show.dailyBudget = true; //打开预算
                    this.editList = [...this.selectedList];
                }
                if (value == '日期') this.show.date = true; //打开时期
                if (value == '时段') this.show.time = true; //打开时段
                if (value == '开启') this.batchUpdate(1); //批量开启
                if (value == '停止') this.batchUpdate(0); //批量停止
                if (value == '还原') this.batchUpdate(0); //批量还原
                if (value == '归档') this.batchUpdate(3); //批量归档
            }
        },
        /**
         * 批量更新状态
         * @param status:string or number 要更新的状态
         */
        async batchUpdate(status) {
            let arr = [];
            this.originData
                .filter((item) => item.selected)
                .map((item) =>
                    arr.push({
                        id: item.id,
                        status: status,
                    })
                );

            const res = await this.$axios.post(this.$port.campaign.batchUpdate, arr);
            if (res.status == 200) {
                this.getCampaignList();
                this.$Message.success({
                    content: '修改成功',
                    duration: 2,
                });
                this.currentOffer = '';
            } else {
                this.$Message.error({
                    content: res.message,
                    duration: 3,
                });
            }
        },
        /**
         * @desc: 归档还原
         * @param item:obj 推广对象
         */
        async restoreCampaign(item) {
            const res = await this.$axios.get(this.$port.manager.unArchiveCampaign, {
                params: { campaignId: item.id },
            });
            this.$axios.commonCallback(res, '还原成功');
            this.getCampaignList();
        },
        /*
         * @desc: 限制只能输入数字
         * @param event:obj 事件对象
         */
        onInputNumber(event) {
            this.mixinRegNum(event, 2);
        },
        /**
         * @desc: 修改日期
         * @param event:obj 事件对象
         */
        onDateChange(date) {
            this.date = [...date];
        },
        /**
         * @desc: 修改时段字符串
         * @param timeStr:string 时段字符串
         */
        onTargetTimeChange(timeStr) {
            // console.log(timeStr);
            this.targetTime = timeStr;
        },
        /**
         * @desc: 确认预算
         */
        confirmBudget({ type, value }) {
            this.show.dailyBudget = false;
            this.submitBudget(
                this.editList.map((item) => ({
                    id: item.id,
                    dailyBudget: 0,
                    dailyClick: 0,
                    dailyImp: 0,
                    [type]: ~~value,
                }))
            );
        },
        /*
         * @desc: 提交修改出价出价
         */
        async submitBidPrice({ type, value }) {
            const arr = this.editList.map((item, index) => ({
                id: item.id,
                bidPrice: value,
                bidType: type,
            }));
            const res = await this.$axios.post(this.$port.campaign.batchUpdate, arr);
            this.afterSubmit(res);
        },
        /**
         * @desc: 提交修改日期
         */
        async submitDate() {
            let arr = [];
            this.selectedList.forEach((item, index) =>
                arr.push({
                    campaignId: item.id,
                    startDay: this.date[0],
                    endDay: this.date[1],
                })
            );
            const params = arr;
            const res = await this.$axios.post(this.$port.campaign.batchUpdate, params);
            this.afterSubmit(res);
        },
        /**
         * @desc: 提交预算
         * @param params:obj 提交的参数
         */
        async submitBudget(params) {
            const res = await this.$axios.post(this.$port.campaign.batchUpdate, params);
            this.afterSubmit(res);
        },
        /**
         * @desc: 提交修改时段
         */
        async submitTime() {
            const arr = this.selectedList.map((item, index) => ({
                id: item.id,
                targetTime: this.show.targetTime ? this.targetTime : '',
            }));
            const res = await this.$axios.post(this.$port.campaign.batchUpdate, arr);
            this.afterSubmit(res);
        },
        /**
         * @desc: 批量操作后回调
         * @param res:obj 请求回调对象
         */
        afterSubmit(res) {
            if (res.status == 200) {
                this.$Message.success({ content: '修改成功', duration: 1.5 });
                this.getCampaignList(false);
            } else {
                this.$Message.error({ content: '修改失败', duration: 1.5 });
            }
        },
    },
};
</script>
<style lang="scss">
@import 'src/style/frequently.scss';
@import 'src/style/cModal.scss';

#group-detail {
    .header-search {
        width: 3rem !important;
    }
    #c-body .c-body-section .c-body-table .table-tr {
        .table-td-primary {
            min-width: 0.4rem;
        }
        .table-td-primary:nth-of-type(1) {
            padding-right: 0;
            padding-left: 0.2rem;
        }
        //展示删除创意按钮
    }
    .ivu-select-dropdown {
        overflow: auto !important;
        max-height: 3.3rem !important;
        .dropdown-tool {
            display: flex;
            align-items: center;
            padding: 0 0.1rem 0.1rem 0.1rem;
            max-width: 3.2rem;
            .dropdown-search {
                flex: 1 1 auto;
            }
            .blue-btn {
                flex: 0 0 auto;
                margin-left: 0.15rem;
                color: #237ec5;
                font-size: 0.14rem;
            }
        }
    }
    .c-ex-dropdown {
        position: relative;
        .campaign-dropdown-item {
            min-width: 3.2rem;
        }
    }
    .edit-box {
        justify-content: flex-end;
        display: flex;
        width: 2.5rem;
        position: relative;
        align-items: center;
        .edit {
            width: 2.5rem;
            height: 100%;
            display: flex;
            align-items: center;
            position: absolute;
            flex: 1;
            .close-btn {
                cursor: pointer;
                position: absolute;
                right: 1.2rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/PromotionManagement/Campaign.vue